var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('textarea',{class:{
    'iqos-textarea': true,
    'iqos-textarea-readonly': _vm.readonly
  },attrs:{"readonly":_vm.readonly,"rows":"6","placeholder":_vm.placeholder},domProps:{"value":_vm.value},on:{"blur":function($event){return _vm.$emit('blur')},"input":function (ev) { return _vm.$emit('input', ev.target.value); }}})}
var staticRenderFns = []

export { render, staticRenderFns }